import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link, { withPrefix } from 'gatsby-link';
import Headroom from 'react-headroom';
import { Fade } from 'react-reveal';
import StudentsNavModal from '../../components/StudentsNavModal/StudentsNavModal';
import AboutModal from '../../components/AboutModal/AboutModal';
import styles from './Navigation.module.scss';
import './Headroom.scss';

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showAboutModal: false
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenAboutModal = this.handleOpenAboutModal.bind(this);
    this.handleCloseAboutModal = this.handleCloseAboutModal.bind(this);
  }

  handleOpenModal(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleOpenAboutModal(e) {
    e.preventDefault();
    this.setState({ showAboutModal: true });
  }

  handleCloseAboutModal() {
    this.setState({ showAboutModal: false });
  }

  render() {
    const { projects, isAlwaysPinned } = this.props;
    const { showModal, showAboutModal } = this.state;
    const headroomClassName = isAlwaysPinned ? 'headroom--alwayspinned' : null;
    return (
      <header>
        <Headroom disableInlineStyles disable={isAlwaysPinned} className={headroomClassName}>
          <Fade down duration={1500}>
            <nav className={styles.navigation}>
              <a href="#" onClick={this.handleOpenAboutModal} className={styles.navLink}>
                ABOUT
              </a>
              <Link to="/">
                <img src={withPrefix('/logo.svg')} className="logoLg"/>
                <img src={withPrefix('/logo_compressed.svg')} className="logoSm"/>
              </Link>
              <a href="#" onClick={this.handleOpenModal} className={styles.navLink}>
                STUDENTS
              </a>
            </nav>
          </Fade>
        </Headroom>
        <nav className={styles.mobileNav}>
          <Link to="/" className={styles.logoSm}>
            <img src={withPrefix('/logo_short.svg')}/>
          </Link>
          <a href="#" onClick={this.handleOpenAboutModal} className={styles.navLink}>
            ABOUT
          </a>
          <a href="#" onClick={this.handleOpenModal} className={styles.navLink}>
            STUDENTS
          </a>
        </nav>
        <StudentsNavModal
          isOpen={showModal}
          handleClose={this.handleCloseModal}
          projects={projects}
        />
        <AboutModal
          isOpen={showAboutModal}
          handleClose={this.handleCloseAboutModal}
        />
      </header>
    );
  }
};

Navigation.propTypes = {
  projects: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.jsx